<template>
  <UiMaskedLink
    :href="objectUrl()"
    :new-tab="isNewTab"
    :masking-disabled="!maskedLink"
    :masking-aria-label="t('aria_label_object_card', { hausname: props.item?.hausname, haustyp: props.item?.haustyp })"
    masking-disabled-css="h-full flex flex-col"
    :link-semantics="false"
    :external="true"
    :class="[
      {'bg-white rounded-xl focus:outline-hidden border border-neutral-200': (searchresult || normal || wishlist || objectslider) && !(props.highlighted || props.serpHighlighted)},
      {'bg-white text-neutral-800 focus:outline-hidden relative text-left flex flex-col h-full': leafletmap},
      {'rounded-xl border border-neutral-200': leafletmap && !props.serpHighlighted },
      {'rounded-b-xl': leafletmap && props.serpHighlighted },
      {'bg-white shadow-md rounded-t-none rounded-b-xl outline-offset-0 focus:outline-hidden outline-solid outline-2': props.highlighted || props.serpHighlighted},
      {'outline-petrol-500': !unavailableOnDates && (props.highlighted || props.serpHighlighted)},
      {'outline-neutral-500': unavailableOnDates && (props.highlighted || props.serpHighlighted)},
      'relative text-left flex flex-col h-full text-xs'
    ]"
    @click="tracking"
    @keydown.enter="tracking"
  >
    <div
      v-if="props.highlighted && props.highlightedIconUrl !== ''"
      class="absolute top-0 left-0 -mt-2 ml-[-14px] z-20 invisible lg:visible"
    >
      <img :loading="lazyLoading ? 'lazy' : 'eager'" width="26" height="35" alt="Mapmarker" :src="props.highlightedIconUrl">
    </div>
    <div class="relative">
      <div
        class="absolute top-0 left-0 mt-5 ml-5 z-10"
      >
        <div
          v-if="props.item?.wrong_personen"
          class="bg-neutral-800 text-white text-sm py-1 px-2 rounded-full mb-1"
        >
          <UiLanguagePlaceholder domain="page.merkzettel" name="wrong_filter_personen" />
        </div>
        <div
          v-if="props.item?.wrong_date"
          class="bg-neutral-800 text-white text-sm py-1 px-2 rounded-full"
        >
          <UiLanguagePlaceholder domain="page.merkzettel" name="wrong_filter_date" />
        </div>
      </div>
      <div v-if="!wishlistNone" class="absolute top-1 right-[0.1rem] z-10 " @click.stop.prevent>
        <WishlistHeartIcon v-if="wishlistRemove" :object-id="props.item?.nr" wishlist-style="remove" />
        <WishlistHeartIcon v-else :object-id="props.item?.nr" />
      </div>
      <div class="absolute top-0 left-0 mt-3.5 ml-2.5 flex gap-2.5 z-10 w-[calc(100%-3.25rem)] leading-4">
        <div
          v-if="(searchresult || leafletmap) && props.item?.buchungssystem == BookingSystemEnum.Onlinebuchung"
          :class="[
            {'opacity-30': filterWishlistVisible },
            ' bg-petrol-500 rounded-xl text-white py-1 px-2'
          ]"
        >
          <UiLanguagePlaceholder domain="SharedObjectCard" name="sofort_buchen" />
        </div>
        <div
          v-if="portal == 'http://www.sylt-travel.de' && props.item?.exklusiv"
          :class="[
            {'opacity-30': filterWishlistVisible },
            ' bg-neutral-700 rounded-xl text-white py-1 px-2'
          ]"
        >
          <UiLanguagePlaceholder domain="SharedObjectCard" name="sylt_exclusive" />
        </div>
        <div
          v-if="objectHelper.isNewObject(props.item?.freigeschaltet_seit)"
          :class="[
            {'opacity-30': filterWishlistVisible},
            'bg-neutral-700 rounded-xl text-white py-1 px-2'
          ]"
        >
          <UiLanguagePlaceholder domain="SharedObjectCard" name="new" />
        </div>
      </div>
      <div
        v-if="(searchresult || leafletmap) && (props.flexdate || (props.item?.variability_from && props.item?.variability_to) || props.alternativeObject)"
        :class="[
          {'opacity-30': filterWishlistVisible },
          { 'bottom-9': portal == 'http://www.sylt-travel.de' && props.item?.exklusiv },
          { 'bottom-6': !props.item?.exklusiv || (props.item?.exklusiv && portal != 'http://www.sylt-travel.de') },
          'absolute left-0 mt-5 px-5 w-full text-center z-10'
        ]"
      >
        <div
          v-if="(searchresult || leafletmap) && (props.flexdate || (props.item?.variability_from && props.item?.variability_to))"
          :class="['bg-white rounded-2xl inline-block px-3', {'leading-5' : searchresult}, {'leading-[1.2] py-0.5 text-sm' : leafletmap}]"
        >
          <span
            v-if="props.alternativeObject"
            class="block"
          >
            {{ t('variability_info') }}
          </span>
          <UiLanguagePlaceholder
            domain="SearchResults"
            name="variability_example"
            :variables="{ arrival: formatDateWithDay(props.item?.variability_from), departure: formatDateWithDay(props.item?.variability_to) }"
          />
        </div>
        <div
          v-if="(searchresult || leafletmap) && props.alternativeObject && !(props.flexdate || (props.item?.variability_from && props.item?.variability_to))"
          :class="['bg-white rounded-2xl inline-block px-3', {'leading-5 py-0.5' : searchresult}, {'leading-[1.2] py-0.5 text-sm' : leafletmap}]"
        >
          {{ t('surrounding_area') }}
        </div>
      </div>
      <div
        v-if="images.length > 1 && props.builderCarousel"
        :class="[
          {'opacity-30': filterWishlistVisible },
          { 'rounded-t-xl' : !(props.highlighted || props.serpHighlighted) },
          { 'rounded-t-none' : (props.highlighted || props.serpHighlighted) },
          'w-full overflow-hidden relative'
        ]"
      >
        <SharedPictureCarousel
          :nested-carousel="nestedCarousel"
          :item="props.item"
          :lazy-loading="lazyLoading"
          :class="[ {'rounded-t-xl overflow-hidden' : objectslider }]"
        />
      </div>
      <div
        v-else
        :class="[
          {'opacity-30': filterWishlistVisible },
          'w-full overflow-hidden rounded-t-xl'
        ]"
      >
        <img
          :src="images[0] ?? ''"
          :alt="props.item?.nr"
          height="220"
          width="405"
          :class="[
            {'rounded-t-xl ' : objectslider },
            'aspect-[16/10] object-cover object-center w-full bg-neutral-100'
          ]"
          loading="lazy"
        >
      </div>
    </div>
    <div
      :class="[
        {'px-2.5 pt-2 pb-3' : objectslider || searchresult || normal || wishlist || leafletmap },
        {'opacity-30': filterWishlistVisible },
        'flex flex-col flex-1 justify-between'
      ]"
    >
      <div class="flex flex-col gap-0.5 mb-3 text-sm">
        <div class="text-neutral-600">
          <Suspense>
            <UiIcon src="/svg/icons/location.svg" height="12px" width="12px" class="fill-neutral-600 -mt-px inline-block" />
          </Suspense>
          {{ props.item?.region }}
          <span class="mx-0.5">·</span>
          {{ props.item?.ortsname }}
          <template v-if="objectslider && Math.round(props.item?.distance) > 0 && props.item?.ortsname != regionDistanceTo.trim()">
            <span class="mx-0.5">·</span>
            <UiLanguagePlaceholder domain="SharedObjectCard" name="distance_to_region" :variables="{ distance : Math.round(props.item?.distance), region : regionDistanceTo }" />
          </template>
        </div>
        <div
          v-if="!props.item?.generated_description"
          class="text-lg font-semibold leading-5 line-clamp-2 mb-0.5"
        >
          <UiMaskedLink :masking-disabled="true" :href="objectUrl()">
            {{ props.item?.hausname }}
          </UiMaskedLink>
        </div>
        <div
          v-if="props.item?.generated_description && objectslider"
          :class="['text-lg font-semibold leading-5 hyphens-auto line-clamp-2 mb-0.5']"
        >
          {{ props.item?.generated_description }}
        </div>
        <div class="hyphens-auto text-neutral-600 text-sm line-clamp-1">
          <template
            v-if="!props.item?.generated_description"
          >
            {{ props.item?.haustyp }}
            <span class="mx-0.5">·</span>
          </template>
          {{ props.item?.wohnflaeche }} m²
          <span class="mx-0.5">·</span>
          {{ props.item?.personen }}
          <UiLanguagePlaceholder domain="SharedObjectCard" name="guests" />
          <template v-if="props.item?.schlafzimmer > 0">
            <span class="ml-1 mr-0.5">·</span>
            {{ props.item?.schlafzimmer }} <UiLanguagePlaceholder domain="SharedObjectCard" name="bedroom" />
          </template>
        </div>
      </div>
      <div>
        <div v-if="objectslider && props.lastminute" class="text-lg font-light">
          {{ props.item?.lastminute?.zeitraum_kurz?.von }} - {{ props.item?.lastminute?.zeitraum_kurz?.bis }}:
          <span class="font-semibold ml-1">{{ props.item?.lastminute?.prozent_ersparnis }}% sparen!</span>
        </div>
        <div v-if="props.item?.subtitle" class="text-sm text-neutral-600 line-clamp-1 mb-1">
          {{ props.item?.subtitle }}
        </div>
        <div
          v-if="searchresult || leafletmap"
          :class="[{'bg-green-50' : props.item?.free_cancellation_until > 0 && props.item?.free_x_days !== null }, 'text-sm font-semibold text-green-900 inline-block py-0.5 px-2 rounded-md']"
        >
          <template v-if="props.item?.free_cancellation_until > 0 && props.item?.free_x_days !== null">
            {{ t('free_cancellation') }}
          </template>
          <span v-if="props.item?.free_cancellation_until > 0 && props.item?.free_x_days === null" :class="[{'invisible' : !leafletmap}, {'hidden' : leafletmap}]">Cancellation date passed</span>
          <span v-if="props.item?.free_cancellation_until < 0" :class="[{'invisible' : !leafletmap}, {'hidden' : leafletmap}]">NO cancellation</span>
        </div>
        <div
          v-if="totalPrice || pricePerNight || props.item?.bewertungen"
          class="flex flex-wrap flex-row justify-between items-end gap-x-1 gap-y-1 border-t border-neutral-200 pt-2 mt-2"
        >
          <div>
            <Suspense>
              <SharedStars
                v-if="props.item?.bewertung_durchschnitt"
                :rating-text="true"
                :rating="props.item?.bewertung_durchschnitt"
                :number-of-reviews="props.item?.bewertungen || props.item?.bewertung_count"
                design="compact_card"
              />
            </Suspense>
            <Suspense>
              <SharedStars
                v-if="props.item?.bewertung"
                :rating-text="true"
                :rating="props.item?.bewertung"
                :number-of-reviews="props.item?.bewertungen"
                design="compact_card"
              />
            </Suspense>
          </div>
          <div
            :class="[
              {'text-neutral-800': props.design && !filterWishlistVisible },
              'text-lg text-left'
            ]"
          >
            <div
              v-if="props.item?.has_lm_boolean_df || props.lastminute || totalPriceDiscountPercentage"
              class="text-right"
            >
              <span
                v-if="totalPriceOriginal"
                class="text-sm mr-1 line-through"
              >
                {{ totalPriceOriginal }}
              </span>
              <div
                :class="['inline-block bg-cta-50 text-sm rounded-sm text-cta-800 py-0.5 px-1.5']"
              >
                <template v-if="totalPriceDiscountPercentage">
                  -{{ totalPriceDiscountPercentage }}
                </template>
                %
              </div>
            </div>
            <span v-if="totalPrice" class="text-sm text-neutral-600">
              <span class="font-semibold text-neutral-900 mr-1 text-xl">{{ totalPrice }}</span>
              <UiLanguagePlaceholder domain="SharedObjectCard" name="total_price_card" />
            </span>
            <span v-else-if="pricePerNight" class="text-sm text-neutral-600">
              <UiLanguagePlaceholder domain="SharedObjectCard" name="from" />
              <span class="font-semibold text-neutral-900 text-xl ml-0.5">{{ pricePerNight }}</span>
              <UiLanguagePlaceholder domain="SharedObjectCard" name="night" />
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="props.highlighted || props.serpHighlighted"
      :class="[
        'block px-2 py-3 text-white text-center text-sm rounded-t-xl font-semibold absolute min-h-[50px] -top-10 left-[-2px] w-[calc(100%+4px)]',
        {'bg-petrol-500': !unavailableOnDates},
        {'bg-neutral-500': unavailableOnDates}
      ]"
    >
      {{ unavailableOnDates ? t('interest_object_not_available_on_dates') : t('interest_object') }}
    </div>
    <div
      v-if="mapMarker"
      class="absolute bottom-[-18px] left-[50%] ml-[-21px] w-[40px] h-[20px] pointer-events-none overflow-hidden"
    >
      <div
        :class="['w-[17px] h-[17px] p-px mt-[-6px] mx-auto bg-white rotate-45 pointer-events-auto', { 'ring-1 ring-offset-0 ring-white': !props.serpHighlighted }]"
      />
    </div>
  </UiMaskedLink>
</template>

<script setup lang="ts">
import type { ComputedRef } from 'vue'
import { useSearchParamsStore } from '~~/stores/searchParams'
import { useGuestsStore } from '~~/stores/guests'
import { useTravelDatesStore } from '~~/stores/travelDates'
import BookingSystemEnum from '~~/types/product/BookingSystemEnum'
import usePrices from '~/composables/usePrices'

type Item = {
  [key: string]: unknown
  bilder_neu?: string[]
}

interface Props {
  item: Item
  design?: string
  rating?: boolean
  onlinebooking?: boolean
  storno?: boolean
  lastminute?: boolean
  syltexclusive?: boolean
  flexdate?: boolean
  favourite?: boolean
  wishlistRemove?: boolean
  wishlistNone?: boolean
  highlighted?: boolean
  highlightedIconUrl?: string
  builderCarousel?: boolean
  maskedLink?: boolean
  wishlistParams?: Record<string, any> | null
  lazyLoading?: boolean
  nestedCarousel?: boolean
  regionDistanceTo?: string
  serpHighlighted?: boolean
  alternativeObject?: boolean
  mapMarker?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  design: 'normal',
  rating: true,
  onlinebooking: false,
  storno: false,
  lastminute: false,
  syltexclusive: false,
  flexdate: false,
  favourite: false,
  wishlistRemove: false,
  wishlistNone: false,
  highlighted: false,
  highlightedIconUrl: '',
  builderCarousel: true,
  maskedLink: true,
  wishlistParams: null,
  lazyLoading: true,
  nestedCarousel: false,
  regionDistanceTo: '',
  serpHighlighted: false,
  alternativeObject: false,
  mapMarker: false
})

const { translate: t } = useTranslations('SharedObjectCard')

const searchresult = computed(() => props.design === 'searchresult')
const leafletmap = computed(() => props.design === 'leafletmap')
const normal = computed(() => props.design === 'normal')
const wishlist = computed(() => props.design === 'wishlist')
const objectslider = computed(() => props.design === 'objectslider')
const filterWishlistVisible = computed(() => props.item?.wrong_personen || props.item?.wrong_date)
const unavailableOnDates = computed(() => props.item?.is_available_on_dates === false)

const objectHelper = useObjectHelper()
const images = computed(() => props.item.bilder_neu ?? [])
const searchParamsStore = useSearchParamsStore()

function objectUrl () {
  if (objectslider.value) {
    return props.item?.url
  }
  if (props.wishlistParams !== null && !filterWishlistVisible.value) {
    return props.item?.url + '#von=' + props.wishlistParams.von + '&bis=' + props.wishlistParams.bis + '&personen=' + props.wishlistParams.personen
  }
  if ((searchresult.value || leafletmap.value) && (props.flexdate || (props.item?.variability_from && props.item?.variability_to))) {
    return props.item?.url + '#von=' + props.item?.variability_from + '&bis=' + props.item?.variability_to + '&personen=' + searchParamsStore.personen
  }
  if (searchParamsStore.von !== '' && searchParamsStore.bis !== '') {
    return props.item?.url + '#von=' + searchParamsStore.von + '&bis=' + searchParamsStore.bis + '&personen=' + searchParamsStore.personen
  }
  return props.item?.url
}
const isNewTab = ref(true)
if (import.meta.client) {
  const userAgent = window.navigator.userAgent
  isNewTab.value = !/(iPad|iPhone)/.test(userAgent)
}

const totalPrice: ComputedRef<string|null> = computed(() => {
  return usePrices().totalPrice(props.item?.vari_price_gesamtpreis ?? props.item?.gesamtpreis)
})
const totalPriceOriginal: ComputedRef<string|null> = computed(() => {
  return usePrices().totalPriceOriginal(
    props.item?.vari_price_gesamtpreis_original ?? props.item?.gesamtpreis_original,
    props.item?.vari_price_gesamtpreis ?? props.item?.gesamtpreis
  )
})
const totalPriceDiscountPercentage: ComputedRef<string|null> = computed(() => {
  return usePrices().totalPriceDiscountPercentage(
    props.item?.vari_price_gesamtpreis_original ?? props.item?.gesamtpreis_original,
    props.item?.vari_price_gesamtpreis ?? props.item?.gesamtpreis
  )
})
const pricePerNight: ComputedRef<string|null> = computed(() => {
  return usePrices().pricePerNight((props.item?.min || props.item?.preis_min), props.item?.lastminute?.tagespreis)
})

function tracking () {
  const { $gtmModules } = useNuxtApp()
  const guests = useGuestsStore()
  const travelDates = useTravelDatesStore()
  $gtmModules.productsModule.sendProductClickEvent(props.item, guests.personen, travelDates.arrival, travelDates.departure)
}

const { currentPortal } = usePortals()
const portal = currentPortal.value.portal.portal

const formatDateWithDay = (date: string|null|undefined) => {
  if (!date) {
    return ''
  }
  const portalDe = currentPortal.value?.portal?.lang === 'de'
  const dateObj = new ExtendedDate(date)

  const dayOfWeek = dateObj.toLocaleDateString(
    (portalDe ? 'de-DE' : 'en-GB'),
    { weekday: 'short' }
  )
  const dayOfMonth = dateObj.toLocaleDateString(
    (portalDe ? 'de-DE' : 'en-GB'),
    { day: '2-digit' }
  )
  const month = dateObj.toLocaleDateString(
    (portalDe ? 'de-DE' : 'en-GB'),
    { month: '2-digit' }
  )

  return `${dayOfWeek} ${dayOfMonth}.${month}`

  // return dateObj.toLocaleDateString(
  //   (portalDe ? 'de-DE' : 'en-GB'),
  //   { weekday: 'short', day: '2-digit', month: '2-digit' }
  // )
}
</script>
